import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "-4 -6 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-4 -6 30 30\" id=\"icon-chevron-down\">\r\n    <path d=\"M7 5.32l5.41-5.2c.17-.16.34-.16.5 0l.97.94c.16.16.16.33 0 .5L7.25 7.91A.35.35 0 0 1 7 8a.35.35 0 0 1-.25-.09L.12 1.56c-.16-.17-.16-.34 0-.5l.97-.94c.16-.16.33-.16.5 0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol